// extracted by mini-css-extract-plugin
export default {"about":"About_about__tm0go","about__content":"About_about__content__deS4b","about__details_digits":"About_about__details_digits__diioh"};